import { captureException } from '@sentry/browser'

const NrSentry = {
  captureError: captureException
}
export default NrSentry
